import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantSameResidencePage = {
  alert: {
    error: 'coapplicant-same-residence-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-same-residence-page.footer.root',
  },
  form: {
    h1: 'coapplicant-same-residence-page.form.h1',
    h2: 'coapplicant-same-residence-page.form.h2',
    housingAmountInput:
      'coapplicant-same-residence-page.form.housing-amount-input',
    housingAmountInputError:
      'coapplicant-same-residence-page.form.housing-amount-input-error',
    root: 'coapplicant-same-residence-page.form.root',
    submitButton: 'coapplicant-same-residence-page.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-same-residence-page.header.drawer-button',
    previousStepButton:
      'coapplicant-same-residence-page.header.previous-step-button',
    root: 'coapplicant-same-residence-page.header.root',
  },
  progress: {
    root: 'coapplicant-same-residence-page.progress.root',
  },
} as const satisfies PageLocatorMap;
